<!-- TODO: Set date of log dynamically -->
@if (selectedDate) {
  <app-card>
    <mat-tab-group animationDuration="0ms">
      <mat-tab label="Food">
        <div class="entries-container">
          <app-food
            [selectedDate]="selectedDate"
            (continueToNext)="onFoodContinue()"
          ></app-food>
        </div>
      </mat-tab>
      <mat-tab label="Mobility">
        <div class="entries-container">
          <app-mobility
            [selectedDate]="selectedDate"
            (continueToNext)="onMobilityContinue()"
          ></app-mobility>
        </div>
      </mat-tab>
      <mat-tab label="Activity">
        <div class="entries-container">
          <app-activities
            [selectedDate]="selectedDate"
            (continueToNext)="onActivityContinue()"
          ></app-activities>
        </div>
      </mat-tab>
    </mat-tab-group>
  </app-card>
}
